module.exports = __webpack_public_path__ + "img/03.0b02d04a.jpg";